module.exports = __webpack_public_path__ + "img/folder_open.9cc860ea.svg";